import { Column } from "../../../../common/components/ColumnsSelector/ColumnsSelector";

export enum ColumnIds {
	TENDER = "tender_id",
	PGID = "pgid",
	PID = "pid",
	PRID = "prid",
	TOURBILLON_REF = "tourbillon_ref",
	PR_STATUS = "pr_status",
	PR_SITE = "pr_site",
	PR_ALPHA_OR_BETA = "pr_alpha_or_beta",
	P_TYPE_NAME = "p_type_name",
	P_TECHNO_NAME = "p_techno_name",
	PRICING_DATE = "pricing_date",
	P_VALIDITY_DATE = "p_validity_date",
	P_PARTY = "p_party",
	P_BASE_CAPA = "p_base_capa",
	CLICKABILITY = "clickability",
	DELIVERY_PERIOD = "delivery_period",
	P_INSTALL_CAPA = "p_install_capa",
	P_PROVISION_TYPE = "p_provision_type",
	P_CHAPTER_51 = "p_chapter_51",
	P_CHAPTER_51_NUMBER_OF_HOURS = "p_chapter_51_number_of_hours",
	CAP_FLOOR = "CAP_FLOOR",
	SETTLEMENT_PERIOD = "SETTLEMENT_PERIOD",
	CUSTOMER_P50 = "customer_p50",
	P50 = "p50",
	PROXY = "proxy",
	LF = "lf",
	QTY = "qty",
	CROSS = "cross",
	GOO_CROSS = "goo_cross",
	GOO_ADJ = "goo_adj",
	XBC = "xbc",
	XPC = "xpc",
	XDPC = "xdpc",
	P50_PROV = "p50_prov",
	MARGIN_PROV = "margin_prov",
	GOO_PRICE = "goo_price",
	APPLY_SET_UP_FEES = "apply_set_up_fees",

	MARGIN_PROVISION = "margin_provision",
	ALPHA_PROVISION = "alpha_provision",
	BETA_PROVISION = "beta_provision",

	ALPHA_BASELOAD = "alpha",
	ALPHAINDEX = "alphaindex",
	BETA = "beta",

	PR_ALPHABASELOADCLIENT = "pr_alphaclient",
	ALPHA_INDEX_CLIENT = "alpha_index_client",
	BETA_CLIENT = "beta_client",
	INDIC = "indic",

	ALPHA_BASELOAD_MARGIN = "alpha_baseload_margin",
	ALPHA_INDEX_MARGIN = "alpha_index_margin",
	BETA_MARGIN = "beta_margin",

	PR_INDICCLIENT = "pr_indicclient",
	PR_FIXING_DT = "pr_fixing_dt",
	PR_BASELOAD_PRICE = "pr_baseload_price",
	PR_BASELOAD_MID = "pr_baseload_mid",
	PR_COMMERCIAL_MARGIN = "pr_commercial_margin",
	PR_FIXPRICE = "pr_fixprice",
	PR_BETAFIX = "pr_betafix",
	PR_CONTRACT_ID = "pr_contract_id",
	CLEANING_WARNING = "cleaning_warning",
	CLICKABILITY_GRANULARITY = "clickability_granularity",
	SHAPE = "shape",
	SETUPFEE = "SetupFee",
	HEDGERATIOPERCENT = "hedge_ration_percent",
	IMBALANCECOSTPROVISION = "ImbalanceCostProvision",
	PROFILECOSTPROVISION = "ProfileCostProvision",
	DELTAPROFILECOSTPROVISION = "DeltaProfileCostProvision",
	SHAPEPROVISION = "ShapeProvision",
	SHAPEBIDASKPROVISION = "ShapeBidAskProvision",
	FIXINGGOOCOMMERCIALMARGIN = "FixingGooCommercialMargin",
	FINALGOOPRICE = "FinalGooPrice",
	NEGATIVEPRICEVALUE = "NegativePriceValue",
	NEGATIVE_PRICE_CONDITIONS = "NegativePriceConditions",
	CURTAILABILITY_FORWARD_CONDITIONS = "CurtailabilityforwardConditions",
	BALANCING_GROUP = "BalancingGroup",
	MARKETING_TYPE = "MarketingType",
	TOTALPOWERMARGIN = "TotalPowerMargin",
	TOTALGOOMARGIN = "TotalGOOMargin",
	GOO_ADJ_INPUT = "goo_adj_input",
	LIVE_PRICING_WAS_USED = "live_pricing_used",

	IS_NODAL = "IS_NODAL",
	BLOCK_SHAPE = "BLOCK_SHAPE",
	ENERGY_BID_ASK = "ENERGY_BID_ASK",
	PRODUCTION_VARIABILITY_BID_ASK = "PRODUCTION_VARIABILITY_BID_ASK",
	CREDIT_COSTS = "CREDIT_COSTS",
}

export interface ColumnConfigPreference {
	version: number;
	data: Column<ColumnIds>[];
}
